import { writable } from "svelte/store";
import { localUserStore } from "../Connection/LocalUserStore";

/**
 * Whether the camera bubbles are collapsed into the dock on the left edge.
 *
 * The bubbles take the whole top strip of the screen and cover the map. The resize handle
 * only makes them smaller, and only in multi-line mode, so there was no way to get rid of
 * them. Docked, every participant becomes a small avatar on the left rail that lights up
 * while they speak, which is enough to know who is around and who is talking.
 *
 * The choice is per browser and outlives a reload: it is a comfort setting, and having to
 * hide the bubbles again on every page load would defeat the point.
 */
function createCamerasDockedStore() {
    const { subscribe, set, update } = writable<boolean>(localUserStore.getCamerasDocked());

    return {
        subscribe,
        set: (docked: boolean) => {
            set(docked);
            localUserStore.setCamerasDocked(docked);
        },
        toggle: () =>
            update((docked) => {
                localUserStore.setCamerasDocked(!docked);
                return !docked;
            }),
    };
}

export const camerasDockedStore = createCamerasDockedStore();
